<template lang="pug">
    #assessment-exit-modal
      .modal-wrapper(v-if="!isRegistration")
        div.content-container
            p.has-text-centered.exit-modal-title Cancel booking
            p.exit-modal-subtitle No problem at all. You can always re-register for this workshop at a later date.
        .button-container
            WtButton.is-fullwidth.modal-exit-button.mb-1( size="medium" @click.native="handleOnConfirm") Confirm cancellation
      .modal-wrapper(v-else)  
        div.content-container
            p.has-text-centered.exit-modal-title Register for workshop
            p.exit-modal-subtitle Once your registration is confirmed, we will share the joining details. You can always cancel your booking later on.
        .button-container
            WtButton.is-fullwidth.modal-exit-button.mb-1( size="medium" @click.native="handleOnConfirm") Confirm registration
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile.vue";

export default {
  name: "CompanionWorkshopRegisterUnregisterModal",
  components: {
    WtButton,
    WtTitle,
    WtTile
  },

  props: {
    isRegistration: {
      type: Boolean,
      default: true,
      required: true
    }
  },

  data() {
    return {};
  },
  methods: {
    handleOnConfirm() {
      this.$emit("onConfirm");
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-wrapper {
  display: flex !important;
  width: 566px !important;
  padding: var(--Spacing-xxxLarge, 32px) var(--Spacing-xxLarge, 24px)
    var(--Spacing-xxLarge, 24px) var(--Spacing-xxLarge, 24px) !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 34px !important;
  border-radius: 20px !important;
  background: #ffffff !important;

  .exit-modal-title {
    font-size: 20px !important;
    font-weight: 700 !important;
    line-height: 24px !important;
    letter-spacing: 0.15px !important;
  }

  .exit-modal-subtitle {
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    color: var(--Tool-Tip-Fill, #1b1d20) !important;
    text-align: center !important;
    font-style: normal !important;
  }
  .content-container {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 26px !important;
    align-self: stretch !important;
    display: flex;
  }
  .button-container {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
    align-self: stretch !important;
    margin: 0px !important;
  }
  .modal-exit-button {
    background-color: #ec493f !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
  }
}

@media screen and (max-width: 578px) {
  #assessment-exit-modal {
    max-width: 342px;
  }
  .modal-wrapper {
    width: 342px !important;
  }
}
</style>
